import React, {useRef} from 'react'
import { delay, motion, useInView } from 'framer-motion'
const ContactMe = () => {
    const icon = {
        hidden: {
          pathLength: 0,
          fill: "rgba(255, 255, 255, 0)"
          
        },
        visible: {
          pathLength: [0.25, 0.5, 0.75, 1],
          fill: ["#e45a8447", '#f017f0d1', '#573c8799', "rgba(255, 255, 255, 1)"]
        }
      }

      const ref = useRef(null)
      const isInView = useInView(ref)
        
  return (
    <div className='contactme' ref={ref}>
   <div className="left-box">


  {isInView &&
   <svg
   id="ROME"
   xmlns="http://www.w3.org/2000/svg"
   width="807.64"
   height="264.92"
   viewBox="0 0 807.64 264.92"
   className="item"
 >
   <g>
     <motion.path
     variants={icon}
     initial="hidden"
     animate="visible"
     transition={{
         default: { duration: 2.5, ease: "easeInOut" },
         fill: { duration: 2.5, ease: [1, 0, 0.8, 1] },
         delay:0.7
       }}
       d="M443.72,494.25a16.73,16.73,0,0,1-9.13-2.87,18.85,18.85,0,0,1-7-8.23l-50.84-98.81H346.7v93.08q0,7.51-7.16,11.28a36,36,0,0,1-32,0q-7.35-3.76-7.34-11.28v-232a14.4,14.4,0,0,1,15-14.68h70.89q23.63,0,42.78,6.8a61.86,61.86,0,0,1,30.61,23.09q11.44,16.31,11.45,44.93,0,20.78-6.08,35.27t-16.65,23.27A70.68,70.68,0,0,1,424,377.18l47.25,87a12.91,12.91,0,0,1,1.08,3,13.3,13.3,0,0,1,.35,2.68q0,5.73-4.29,11.46a33.15,33.15,0,0,1-10.92,9.31A28.7,28.7,0,0,1,443.72,494.25Zm-97-146.42h39.38q17.54,0,27.92-8.6t10.38-29.35q0-21.48-10.38-29.9t-27.92-8.41H346.7Z"
       transform="translate(-300.16 -230.76)"
     />
     <motion.path
     variants={icon}
     initial="hidden"
     animate="visible"
     transition={{
         default: { duration: 2.5, ease: "easeInOut" },
         fill: { duration: 2.5, ease: [1, 0, 0.8, 1] },
         delay:1
       }}
       d="M567.23,495.68a74.84,74.84,0,0,1-38.31-10.2,81.84,81.84,0,0,1-28.28-27,66,66,0,0,1-10.74-36.16V392.93a66.73,66.73,0,0,1,10.38-36A79.88,79.88,0,0,1,605.89,330.1a80,80,0,0,1,28.28,26.32,65.44,65.44,0,0,1,10.74,36.51v29.36a65.39,65.39,0,0,1-10.74,35.8,82.84,82.84,0,0,1-28.46,27.21A74.79,74.79,0,0,1,567.23,495.68Zm0-40.45A28.29,28.29,0,0,0,583,450.57a34.44,34.44,0,0,0,11.45-12.35,32.21,32.21,0,0,0,4.3-15.93V392.93a29.38,29.38,0,0,0-4.3-15.39,38.59,38.59,0,0,0-11.27-12,27.36,27.36,0,0,0-15.93-4.84,28.38,28.38,0,0,0-15.76,4.66,33.87,33.87,0,0,0-11.27,12,31.33,31.33,0,0,0-4.12,15.57v29.36a33.3,33.3,0,0,0,4.12,15.93,33,33,0,0,0,11.27,12.35A28.3,28.3,0,0,0,567.23,455.23Z"
       transform="translate(-300.16 -230.76)"
     />
     <motion.path
     variants={icon}
     initial="hidden"
     animate="visible"
     transition={{
         default: { duration: 2.5, ease: "easeInOut" },
         fill: { duration: 2.5, ease: [1, 0, 0.8, 1] },
         delay:1.5
       }}
       d="M697.18,492.46q-10,0-16.47-4.66c-4.3-3.09-6.44-6.56-6.44-10.38V336.73c0-4.3,2.14-7.75,6.44-10.38s9.78-3.94,16.47-3.94q8.6,0,14.5,3.94c3.94,2.63,5.9,6.08,5.9,10.38v10.74q6.09-10.38,17.9-18.8t29.72-8.41a40.85,40.85,0,0,1,27.21,10A60,60,0,0,1,810,356.06q9.3-18.26,23.8-27t29.9-8.77a60.83,60.83,0,0,1,31,8.41q14.49,8.41,23.62,24.71t9.13,39.55v84.49c0,3.82-2.27,7.29-6.8,10.38s-10,4.66-16.47,4.66A27.76,27.76,0,0,1,888,487.8c-4.53-3.09-6.8-6.56-6.8-10.38V392.93q0-10.74-4.12-17.9a28.13,28.13,0,0,0-10.92-10.91,28.48,28.48,0,0,0-14-3.76A25.88,25.88,0,0,0,839,364.12,30.3,30.3,0,0,0,828.21,375q-4.31,7.17-4.3,17.55v85.2q0,7.88-7.34,11.28a37.36,37.36,0,0,1-15.93,3.4,36.92,36.92,0,0,1-15.39-3.4q-7.53-3.4-7.52-11.28V392.93a34,34,0,0,0-4.12-17.18,30.07,30.07,0,0,0-10.74-11.1,27.28,27.28,0,0,0-14.14-3.94A27.48,27.48,0,0,0,724.56,375q-4.11,7.17-4.11,17.9v84.49c0,3.82-2.27,7.29-6.8,10.38S703.62,492.46,697.18,492.46Z"
       transform="translate(-300.16 -230.76)"
     />
     <motion.path
     variants={icon}
     initial="hidden"
     
     animate="visible"
     transition={{
         default: { duration: 2.5, ease: "easeInOut" },
         fill: { duration: 2.5, ease: [1, 0, 0.8, 1] },
         delay:1.8
       }}
       d="M1041.93,495.68q-25.43,0-44.93-9.13t-30.61-25.77q-11.1-16.65-11.1-38.49V391.86a64.17,64.17,0,0,1,10.56-35.62,78.52,78.52,0,0,1,28.29-26.14q17.72-9.84,39.56-9.84a78.78,78.78,0,0,1,36.69,8.59,73,73,0,0,1,27,23.63q10.38,15,10.38,35.08,0,15.4-5,22a20.9,20.9,0,0,1-12.71,8.23,77.13,77.13,0,0,1-15.93,1.62h-72.67v5.37q0,15.39,11.63,24.88t30.25,9.48q11.82,0,19.69-3.58t13.61-6.8a22,22,0,0,1,10.74-3.22,13.38,13.38,0,0,1,9.3,3.58,24.91,24.91,0,0,1,6.09,8.41,21.38,21.38,0,0,1,2.15,8.42q0,6.09-7.7,13.06t-21.84,11.82Q1061.26,495.68,1041.93,495.68Zm-40.45-103.46h52.26c4.06,0,6.86-.66,8.42-2s2.32-3.88,2.32-7.7a25.14,25.14,0,0,0-4.47-14.68,31,31,0,0,0-11.46-10,33.68,33.68,0,0,0-15.57-3.58,35.49,35.49,0,0,0-15.39,3.4,29.63,29.63,0,0,0-11.64,9.67,24.84,24.84,0,0,0-4.47,14.85Z"
       transform="translate(-300.16 -230.76)"
     />
   </g>
 </svg>
  }
     </div>
 <div className="right-box">
    <p>For more information or to require my services you can contact me by email:
        <br></br>
        <a >
        romeran14@gmail.com
        </a>
</p>
 </div>

    </div>
  )
}

export default ContactMe